<template>
    <v-container>
        <v-layout>
            <v-flex md12>
                <datos-socioeconomicos></datos-socioeconomicos>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
  import DatosSocioeconomicos from '@/components/forms/DatosSocioeconomicos'
  export default {
    name: 'SocioeconomicosPage',
    components: {DatosSocioeconomicos}
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/pages/information/SocioeconomicaPage.vue